<template>
  <div class="overlay">
    <div class="call-flow-modal">
      <img src="@/assets/images/call_flow_modal.png" class="background-img" alt="background-img" />
      <div class="modal-content">
        <div class="modal-title">
          Let’s route the text message for <br />
          “{{ mainLine }}”
        </div>
 <div class="modal-buttons-row">
          
          
        
          <div class="button-container" style="margin-left: 10px; color: #77A9D7; border-color: #77A9D7;">
            Route to a person
            <img src="@/assets/images/call_flow_route_person.png" class="button-img" alt="button-img" />
          </div>
          <div
            v-if="withGroup"
            class="button-container"
            style="margin-left: 10px; color: #EC8145; border-color: #EC8145;"
          >
            Route to a group
            <img
              src="@/assets/images/call_flow_route_group.png"
              class="button-img"
              style="width: 64px;"
              alt="button-img"
            />
          </div>
        </div>
        <div class="modal-subtitle">
          Messages can be routed directly to a person, to a group.
        </div>
        <custom-button
          customStyle="width: 240px; border-radius: 8px; bottom: 25px; align-self: center; height: 50px; margin-top:  20px;"
          :onClick="click"
        >
          Next
        </custom-button>
      </div>
    </div>
  </div>
</template>

<script>
import CustomButton from '@/components/CustomButton';

export default {
  name: 'TextFlowModal',
  components: {
    CustomButton
  },

  props: {
    mainLine: {
      default: "Company's Main Line",
      required: false,
      type: [Number, String]
    },
    withGroup: {
      default: false,
      required: false,
      type: Boolean
    }
  },

  methods: {
    click() {
      this.$emit('select-route', 'menu');
    }
  }
};
</script>

<style scoped lang="scss">
.call-flow-modal {
  position: relative;
  width: 850px;
  height: 480px;
  background-color: #ffffff;
  border-radius: 10px;

  .background-img {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
  }

  .modal-content {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 50px;
  }

  .modal-title {
    margin-top: 65px;
    font-weight: 800;
    font-size: 40px;
    line-height: 48px;
    text-align: center;
    letter-spacing: -0.5px;
    color: $colorTitle;
  }

  .modal-subtitle {
    margin-top: 10px;
    width: 650px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    text-align: center;
    letter-spacing: 0.1px;
    color: #606c82;
  }

  .modal-buttons-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 10px;
    width: 100%;

    .button-container {
      flex: 1;
      height: 140px;
      font-weight: 600;
      font-size: 16px;
      line-height: 20px;
      text-align: center;
      letter-spacing: -0.01em;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #819f77;

      .button-img {
        width: 42px;
        height: 42px;
        margin-top: 10px;
      }
    }
  }
}
</style>
